import { useState } from 'react';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import {
  Layout,
  Row,
  Card,
  Form,
  Input,
  Button,
  Typography,
  Space,
  ConfigProvider,
  message,
  Image,
} from 'antd';
import { loginTheme } from '../../theme';
import client from '../../api/client';
import cookies from "react-cookies";
import { useUser } from "../../providers/user";
import { env } from '../../config/environment';

const { Content } = Layout;
const { Title, Text } = Typography;

export const Login = () => {
  const [loading, setLoading] = useState(false);
  const { getUser } = useUser();

  const handleSubmit = async (values: {email: string, password: string}) => {
    setLoading(true);
    const body = {
      ...values,
    };
    try {
      const { data } = await client.post("/auth/login", body);
      if (data != null) {
        cookies.save("token", data.token, {
          path: "/", // make it visible to every route
          maxAge: 60 * 60 * 24 * 7, // 1 week (seconds)
          secure:  env.production ?? false, // send only over HTTPS – leave false in local dev if needed
          sameSite: "lax",
        });
        await getUser();
      }
    } catch {
      message.error("Cuenta no reconocida. Verifica tu correo y contraseña");
    }
    setLoading(false);
  };

  return (
    <ConfigProvider theme={loginTheme}>
      <Layout style={{ minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
        <Content>
          <Row align="middle"
            justify="center"
            style={{ minHeight: '100vh',
              padding: '0 16px',
              minWidth: "100vw" }}
          >
            <Card
              bordered={false}
              style={{
                maxWidth: 400,
                margin: '0 auto',
                boxShadow: '0 8px 32px rgba(0,0,0,0.05)',
                borderRadius: 24,
                justifyContent: 'center',
              }}
            >
              <div style={{ display: 'flex',
                justifyContent: 'center',
                marginLeft: "2vw",
                alignItems: 'center' }}>
                <Image src="/logo-pollo-loco.png" style={{ width: '80%' }} />
              </div>
              <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <div style={{ textAlign: 'center' }}>
                  <Title level={3} style={{ marginBottom: 8 }}>
                    Bienvenido de vuelta
                  </Title>
                  <Text type="secondary">
                    Inicia sesión
                  </Text>
                </div>

                <Form
                  name="login"
                  initialValues={{ remember: true }}
                  onFinish={handleSubmit}
                  layout="vertical"
                  requiredMark="optional"
                >
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true,
                        message: '¡Por favor ingresa tu correo!' },
                      { type: 'email',
                        message: '¡Por favor ingresa un correo válido!' },
                    ]}
                  >
                    <Input
                      prefix={<UserOutlined />}
                      placeholder="Correo"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    rules={[{ required: true,
                      message: '¡Por favor ingresa tu clave!' }]}
                  >
                    <Input.Password
                      prefix={<LockOutlined />}
                      placeholder="Clave"
                      size="large"
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      block
                      size="large"
                      loading={loading}
                    >
                      Iniciar sesión
                    </Button>
                  </Form.Item>
                </Form>
              </Space>
            </Card>
          </Row>
        </Content>
      </Layout>
    </ConfigProvider>
  );
};
